import { render, staticRenderFns } from "./ProductRequestList.vue?vue&type=template&id=3648a5dc&scoped=true&"
import script from "./ProductRequestList.vue?vue&type=script&lang=js&"
export * from "./ProductRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ProductRequestList.vue?vue&type=style&index=0&id=3648a5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3648a5dc",
  null
  
)

export default component.exports